import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Side } from '@components';
import {
  IconGitHub,
  IconLinkedin,
  IconFacebook,
  IconTwitter,
  IconExternal,
} from '@components/icons';

const StyledSocialList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  &:after {
    content: '';
    display: block;
    width: 1px;
    height: 90px;
    margin: 0 auto;
    background-color: var(--light-slate);
  }

  li {
    &:last-of-type {
      margin-bottom: 20px;
    }

    a {
      padding: 10px;

      &:hover,
      &:focus {
        transform: translateY(-3px);
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const socialLinks = [
  {
    name: 'GitHub',
    url: 'https://github.com/BUPE-NONDO',
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/bupe-nondo-8497061b9/',
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/bupe.king',
  },
  {
    name: 'X',
    url: 'https://x.com/Bupeofficial?t=0A1wTyImkarR2YnX4iQLEQ&s=08',
  },
  {
    name: 'Email',
    url: 'mailto:peternondo1@gmail.com',
  },
];

const iconMap = {
  GitHub: IconGitHub,
  LinkedIn: IconLinkedin,
  Facebook: IconFacebook,
  X: IconTwitter,
  Email: IconExternal,
};

const Social = ({ isHome }) => (
  <Side isHome={isHome} orientation="left">
    <StyledSocialList>
      {socialLinks &&
        socialLinks.map(({ url, name }, i) => {
          const IconComponent = iconMap[name] || IconExternal;
          return (
            <li key={i}>
              <a href={url} aria-label={name} target="_blank" rel="noreferrer">
                <IconComponent />
              </a>
            </li>
          );
        })}
    </StyledSocialList>
  </Side>
);

Social.propTypes = {
  isHome: PropTypes.bool,
};

export default Social;
